import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

interface UnderMaintenanceModeModel {
  isActive: boolean;
  title: string;
  message: string;
}

export type UnderMaintenanceState = {
  underMaintenanceMode: UnderMaintenanceModeModel;
};

const initState: UnderMaintenanceState = {
  underMaintenanceMode: {
    isActive: false,
    title: null,
    message: null,
  },
};

export const useUnderMaintenance = createStore({
  name: 'under-maintenance',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setUnderMaintenanceMode: handler('underMaintenanceMode'),
  };
});
